module.exports = __webpack_public_path__ + "img/XLM.92bc4edd.svg";